import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { UIModes, UIStates } from "../../../vendor_core/core/src/ui/UIStates";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { State } from "../../../vendor_core/core/src/states/State";
import SceneView from "../../../vendor_core/core/src/views/SceneView";
import { Tween } from "../../../vendor_core/core/src/Tween";
import BackgroundHelper from "../view/background/BackgroundHelper";

export default class OkFStartFSState extends State {

    private scene: SceneView;
    protected fade:Tween;
    
    public enter() {
        super.enter();
        let bgImgName = SpinModel.featureMode == 1 ? "Front_Objects_BN1" : "Front_Objects_BN2";
        const bgImgs = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene().sceneSprites;
        bgImgs.forEach(img => img.visible = false);
        bgImgs.get(bgImgName).visible = true;
        this.startFreeSpins();

    }

    private startFreeSpins() {
        SpinModel.enterFreespins();
        UIController.setState(UIStates.FREE_SPINS);
        UIController.setMode(UIModes.FREE_SPINS);
        this.setBackground();
        const scene = ViewManager.getLayer(DefaultLayers.FreespinCounter).setScene("open");
        let counter = scene.sceneTextFields.get("fs_counter");
        counter.visible = true;

        if (SpinModel.tempWinAmount > 0 && SpinModel.accumulatedWin === 0) {
            SpinModel.accumulatedWin = SpinModel.tempWinAmount
        }

        // if (betBarScene.groups.get("free_spins_info")) {
        //     betBarScene.groups.get("free_spins_info").visible = true;
        //     betBarScene.sceneMoneyFields.get("freeSpins_amount").value =
        //         SpinModel.accumulatedWin;
        // }

        this.exit();
    }

    private setBackground() {

        if (SpinModel.featureMode == 1) {
            BackgroundHelper.backgrounBN1Start();
            // this tween delay (4 sec.) have to be .then from backgroundHelper
            // but the start anim is to long (in some case we may have a bigWin on this time)
            // TODO to talk with Cheu to reduce the time of backgrounBN1Start/backgrounBN2Start
            Tween.delayedCall(4, () => {
                BackgroundHelper.backgrounBN1Loop();
            });
        } else {
            BackgroundHelper.backgrounBN2Start();
            Tween.delayedCall(4, () => {
                BackgroundHelper.backgrounBN2Loop();
            });
        }
    }
}
